import {inject, NgModule} from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavbarService } from "../services/navbar.service";
import { PrenotaNuovoAppuntamentoComponent } from "./prenota-nuovo-appuntamento/prenota-nuovo-appuntamento.component";
import { SceltaDataOraPrenotazioneComponent } from "./scelta-data-ora-prenotazione/scelta-data-ora-prenotazione.component";
import { SceltaServiziPrenotazioneComponent } from "./scelta-servizi-prenotazione/scelta-servizi-prenotazione.component";
import { InserimentoDatiPrenotazioneComponent } from "./inserimento-dati-prenotazione/inserimento-dati-prenotazione.component";
import { RiepilogoPrenotazioneComponent } from "./riepilogo-prenotazione/riepilogo-prenotazione.component";
import { ListaPrenotazioniComponent } from "./lista-prenotazioni/lista-prenotazioni.component";
import { DettaglioAppuntamentoComponent } from './dettaglio-appuntamento/dettaglio-appuntamento.component';

const PrePath = 'Appuntamenti/';

@NgModule({
  imports: [
    /* jhipster-needle-add-admin-module - JHipster will add admin modules here */
    RouterModule.forChild([
      {
        path: PrePath + 'lista-prenotazioni', component: ListaPrenotazioniComponent
        ,data:{pageTitle: "appuntamenti.lista-prenotazioni"}
      },
      {
        path: PrePath + 'scelta-data-ora-prenotazione', component: SceltaDataOraPrenotazioneComponent
        ,data:{pageTitle: "appuntamenti.prenota-nuovo-appuntamento"}
      },
      {
        path: PrePath + 'scelta-servizi-prenotazione', component: SceltaServiziPrenotazioneComponent
        ,data:{pageTitle: "appuntamenti.prenota-nuovo-appuntamento"}
      },
      {
        path: PrePath + 'inserimento-dati-prenotazione', component: InserimentoDatiPrenotazioneComponent
        ,data:{pageTitle: "appuntamenti.prenota-nuovo-appuntamento"}
      },
      {
        path: PrePath + 'riepilogo-prenotazione', component: RiepilogoPrenotazioneComponent
        ,data:{pageTitle: "appuntamenti.prenota-nuovo-appuntamento"}
      },
      {
        path: PrePath + 'dettaglio-appuntamento', component: DettaglioAppuntamentoComponent
      },

    ]),
  ],
})
export class AppuntamentiRoutingModule { }
